"use strict";

var _slicedToArray = require("/codebuild/output/src305412778/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useLocalStorage = exports.setLocalStorageItem = exports.getLocalStorageItem = void 0;

var react_1 = require("react");

var getLocalStorageItem = function getLocalStorageItem(key, defaultValue) {
  var _a;

  if (typeof window !== "undefined") {
    var storedValue = (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(key);

    if (storedValue !== null) {
      return storedValue;
    } else {
      return JSON.stringify(defaultValue);
    }
  } else {
    return JSON.stringify(defaultValue);
  }
};

exports.getLocalStorageItem = getLocalStorageItem;

var setLocalStorageItem = function setLocalStorageItem(key, value) {
  if (typeof window !== "undefined") {
    window === null || window === void 0 ? void 0 : window.localStorage.setItem(key, JSON.stringify(value));
  }
};

exports.setLocalStorageItem = setLocalStorageItem;

var useLocalStorage = function useLocalStorage(key, defaultValue) {
  var currentStoredValue = (0, exports.getLocalStorageItem)(key, defaultValue);
  var getCurrentValue = currentStoredValue && JSON.parse(currentStoredValue) || defaultValue;

  var _ref = (0, react_1.useState)(getCurrentValue),
      _ref2 = _slicedToArray(_ref, 2),
      value = _ref2[0],
      setValue = _ref2[1];

  (0, react_1.useEffect)(function () {
    (0, exports.setLocalStorageItem)(key, value);
  }, [value]);
  return [value, setValue];
};

exports.useLocalStorage = useLocalStorage;